module.exports = __webpack_public_path__ + "img/scammer_4.9a2c7752.png";